/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, february 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function initializeCashPayment(payload: any) {
  return {
    type: ActionTypes.CASH_PAYMENT_REQUEST,
    payload,
  };
}

export function initializeCardPaymentAction(payload: any) {
  return {
    type: ActionTypes.CARD_PAYMENT_REQUEST,
    payload,
  };
}

export function paymentIngenicoCompleteAction(payload: Object) {
  return {
    type: ActionTypes.PAYMENT_INGENICO_COMPLETE_REQUEST,
    payload,
  };
}

export function validateGiftCardAction(payload: Object) {
  return {
    type: ActionTypes.VALIDATE_GIFTCARD_REQUEST,
    payload,
  };
}

export function paymentGiftCardInit(payload: Object) {
  return {
    type: ActionTypes.PAYMENT_GIFT_CARD_INIT_REQUEST,
    payload,
  };
}

export function paymentGiftCardComplete(payload: Object) {
  return {
    type: ActionTypes.PAYMENT_GIFT_CARD_COMPLETE_REQUEST,
    payload,
  };
}

export function retryPOSPayment(payload: any) {
  return {
    type: ActionTypes.RETRY_POS_PAYMENT_REQUEST,
    payload: { ...payload },
  };
}
